/** @format */
import angular from 'angular';
import _ from 'lodash';
import moment from 'moment';
import { authServiceModule, localeServiceModule } from 'sis-common';
import { personGroupModelModule } from '../model/personGroup.model';
import { commonStudyRightServiceModule } from './studyRight.service';

export const studyRightSnapshotServiceModule = 'sis-components.service.studyRightSnapshotService';

/*
 * Deprecated: use: "frontend-angular/projects/sis-components/webapp/lib/service/study-right-snapshot-entity.service.ts" instead.
 * */
(function () {
    studyRightSnapshotService.$inject = ['$http'];
    angular
        .module(studyRightSnapshotServiceModule, [
            localeServiceModule,
            authServiceModule,
            personGroupModelModule,
            commonStudyRightServiceModule,
        ])
        .factory('studyRightSnapshotService', studyRightSnapshotService);

    function studyRightSnapshotService($http) {
        return {
            saveSnapshot(studyRight, snapshotDateTime) {
                if (snapshotDateTime) {
                    return $http.put(`/ori/api/study-rights/${studyRight.id}/${snapshotDateTime}`, studyRight).then(result => result.data);
                }
                return $http.put(`/ori/api/study-rights/${studyRight.id}/-inf`, studyRight).then(result => result.data);
            },
            findSnapshotsForStudyRight(studyRight) {
                return $http.get(`/ori/api/study-rights/${studyRight.id}/snapshots`).then(result => result.data);
            },
            deleteSnapshot(studyRightId, snapshotDateTime) {
                if (snapshotDateTime) {
                    return $http.delete(`/ori/api/study-rights/${studyRightId}/${snapshotDateTime}`).then(result => result.data);
                }
                return $http.delete(`/ori/api/study-rights/${studyRightId}/-inf`).then(result => result.data);
            },
            getSnapshotViewType(snapshot, currentSnapshot) {
                const { snapshotDateTime } = snapshot;
                const currentSnapshotDateTime = currentSnapshot.snapshotDateTime;
                if (snapshotDateTime === currentSnapshotDateTime) {
                    return 'CURRENT';
                }
                if (!snapshotDateTime) {
                    return 'PAST';
                }
                if (!currentSnapshotDateTime) {
                    return 'FUTURE';
                }
                return moment(snapshotDateTime).isBefore(moment(currentSnapshotDateTime)) ? 'PAST' : 'FUTURE';
            },
            // Sort snapshots with null snapshotDateTime first
            getSortedSnapshots(snapshots) {
                return (snapshots || []).sort((value1, value2) => {
                    const dt1 = _.get(value1, 'snapshotDateTime');
                    const dt2 = _.get(value2, 'snapshotDateTime');
                    if (!dt1) {
                        return -1;
                    }
                    if (!dt2) {
                        return 1;
                    }
                    return Math.sign(moment(dt1) - moment(dt2));
                });
            },
        };
    }
})();
